import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyDpVyS02iWHVxbKfYaTwTo5DBSEq2dPXmo",
  authDomain: "loginform-dbbde.firebaseapp.com",
  projectId: "loginform-dbbde",
  storageBucket: "loginform-dbbde.appspot.com",
  messagingSenderId: "807571829440",
  appId: "1:807571829440:web:bab6d3a5fa1697279bf325"
};
                                           
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };